export default __webpack_public_path__ + "10b4a9e03ff564c95fbac8d9eb25492e.svg";